import { PropsWithChildren, ReactElement } from 'react';

import { ProgressCircle } from '@spotify-internal/encore-web';
import { ResourceRecoveryCardProvider } from '@spotify/confidence-common-react';
import { NotFoundContent } from '@spotify/confidence-core-react';

import { useAccounts } from '../../hooks';
import { WorkspacePicker } from '../WorkspaceSelect';

const WorkspaceRecoveryCard = (): ReactElement => {
  const { accounts, isLoading } = useAccounts();

  if (isLoading) {
    return (
      <NotFoundContent.Recovery
        title="Loading"
        description="Checking available options."
      >
        <ProgressCircle size="small" aria-label="Loading" />
      </NotFoundContent.Recovery>
    );
  }

  if (accounts.length > 1) {
    return (
      <NotFoundContent.Recovery
        title="Try another workspace"
        description="This resource may be in another workspace."
      >
        <WorkspacePicker />
      </NotFoundContent.Recovery>
    );
  }

  return <NotFoundContent.DefaultRecovery />;
};

export const ResourceRecoveryProvider = ({
  children,
}: PropsWithChildren): ReactElement => (
  <ResourceRecoveryCardProvider value={WorkspaceRecoveryCard}>
    {children}
  </ResourceRecoveryCardProvider>
);
